import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const ApplicationIcon = (): JSX.Element => (
  <SVGUniqueID>
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#a)">
        <rect width={32} height={32} rx={16} fill="#FFCB4A" />
        <g clipPath="url(#b)">
          <path d="M24.39 9.46H7.952v22.79H24.39z" fill="#fff" />
          <path
            d="M24.39 28.244v4.005H7.952V9.46h2.81c-.008.123-.008.25-.008.374a19.16 19.16 0 0 0 3.874 11.581 19.27 19.27 0 0 0 9.762 6.83"
            fill="#EFEFEF"
          />
          <path
            d="m17.571 30.862.66-1.453 8.453-8.453.793.792-8.454 8.454z"
            fill="#FCDA35"
          />
          <path
            d="m20.874 26.767-1.85 1.85.793.792 1.85-1.85z"
            fill="#7F1D1D"
          />
          <path
            d="m26.684 20.956.528-.529a.374.374 0 0 1 .528 0l.264.265a.374.374 0 0 1 0 .528l-.528.528z"
            fill="#B45656"
          />
          <path d="M16.173 20.294h6.725v1.12H9.448v-1.12z" fill="#FCDA35" />
          <path
            d="M14.63 21.415H9.448v-1.121h4.397q.37.577.785 1.12"
            fill="#FACA00"
          />
          <path
            d="m28.005 21.22-.527.527-.396-.396.792-.792.13.13a.377.377 0 0 1 0 .531"
            fill="#7F1D1D"
          />
          <path
            d="m27.082 21.351-5.813 5.814.396.396 5.813-5.814z"
            fill="#FACA00"
          />
          <path d="m21.27 27.164-1.85 1.85.396.395 1.85-1.85z" fill="#7F1D1D" />
          <path
            d="m19.813 29.41-.792.792-1.45.661.004-.008 1.842-1.841z"
            fill="#FACA00"
          />
          <path
            d="M24.39 23.436a.187.187 0 0 1-.187-.186V9.647H8.138v1.307a.187.187 0 0 1-.373 0V9.46c0-.103.083-.187.186-.187H24.39c.103 0 .186.084.186.187v13.79a.187.187 0 0 1-.186.186m0 9H7.95a.187.187 0 0 1-.186-.187V10.816a.187.187 0 0 1 .373 0v21.246h16.065v-7.228a.187.187 0 0 1 .373 0v7.415a.187.187 0 0 1-.186.187"
            fill="#09092D"
          />
          <path
            d="M17.57 31.048a.187.187 0 0 1-.17-.264l.66-1.452a.2.2 0 0 1 .037-.055l8.454-8.453a.187.187 0 0 1 .264 0l.793.793a.187.187 0 0 1 0 .264l-8.454 8.453a.2.2 0 0 1-.055.038l-1.452.66a.2.2 0 0 1-.077.016m.816-1.53-.44.967.968-.439 8.298-8.298-.53-.528z"
            fill="#09092D"
          />
          <path
            d="M19.816 29.596a.2.2 0 0 1-.132-.055l-.792-.792a.187.187 0 0 1 .264-.264l.792.792a.187.187 0 0 1-.132.319m1.85-1.85a.2.2 0 0 1-.133-.054l-.792-.793a.187.187 0 0 1 .264-.264l.792.793a.187.187 0 0 1-.131.318m5.811-5.811a.187.187 0 0 1-.132-.319l.529-.529a.187.187 0 0 0 0-.264l-.265-.264a.19.19 0 0 0-.264 0l-.528.528a.187.187 0 0 1-.265-.264l.53-.528a.575.575 0 0 1 .792 0l.264.265a.56.56 0 0 1 0 .792l-.529.529a.2.2 0 0 1-.132.054m-4.58-9.674h-7.098a.187.187 0 0 1 0-.373h7.098a.187.187 0 0 1 0 .373m0 2.242h-7.098a.187.187 0 0 1 0-.374h7.098a.187.187 0 0 1 0 .374m0 2.241h-7.098a.187.187 0 0 1 0-.373h7.098a.187.187 0 0 1 0 .373m0 4.857H9.447a.187.187 0 0 1-.186-.187v-1.12c0-.104.083-.187.187-.187h1.867a.187.187 0 0 1 0 .373h-1.68v.747H22.71v-.747h-6.538a.187.187 0 0 1 0-.373h6.725c.103 0 .187.083.187.187v1.12a.187.187 0 0 1-.187.187"
            fill="#09092D"
          />
          <path
            d="M14.303 20.48h-1.868a.187.187 0 0 1 0-.373h1.868a.187.187 0 0 1 0 .373"
            fill="#09092D"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <rect width={32} height={32} rx={16} fill="#fff" />
        </clipPath>
        <clipPath id="b">
          <path fill="#fff" d="M4.777 8.9h23.91v23.91H4.777z" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);
export { ApplicationIcon };
